@use 'src/global/variables.scss' as var;

c-form-button {
    text-align: center;
    align-content: center;
    margin-left: 5% !important;

    .full-right {
        margin-top: -10px !important;
        margin-left: 45% !important;
        width: 45% !important;
    }

    .dark {
      padding: 10px !important;
      background: var.$primary-color !important;
      box-shadow: var.$primary-screen-background-color !important;
      color: white !important;

      svg {
          color: white !important;
          max-width: 25px;
      }
    }

    .left {
        margin-right: 8px !important;
        width: 40% !important;
    }

    .right {
        margin-left: 8px !important;
        width: 40% !important;
    }

    .submit-button {
        font-size: 1em;
        background: var.$text-color-light;
        color: var.$primary-color;
        border: 1px solid currentColor;
        cursor: pointer;

        width: 90%;
        padding: 0.5rem 1.5rem;
        margin: 10px 0 10px 0;
        border-radius: 10px;
    }

    .submit-container {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        font-weight: bold;
    }

    svg {
        color: var.$primary-color;
        max-width: 25px;
    }
}